import Component from "./Vibe";
import Illustration from "./components/Illustration/VibeIllustration";
import MainButton from "./components/MainButton/VibeMainButton";
import SecondaryButton from "./components/SecondaryButton/VibeSecondaryButton";
import Subtitle from "./components/Subtitle/VibeSubtitle";
import Title from "./components/Title/VibeTitle";

export interface IVibeExtensions {
    Illustration: typeof Illustration;
    Subtitle: typeof Subtitle;
    Title: typeof Title;
    MainButton: typeof MainButton;
    SecondaryButton: typeof SecondaryButton;
}

export const Vibe: typeof Component & IVibeExtensions = Object.assign(
    Component,
    {
        Illustration,
        Subtitle,
        Title,
        MainButton,
        SecondaryButton,
    },
);

export type { VibeProps } from "./types";
